import { render, staticRenderFns } from "./FundPanel.vue?vue&type=template&id=8c820b8a"
import script from "./FundPanel.vue?vue&type=script&lang=js"
export * from "./FundPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports